import { useEffect } from "react";
import "./TermsConditionsStyle.css"; // Reusing the same styles

const ShippingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <h1 className="legal-heading">Shipping Policy</h1>
      <div className="legal-content">
        <div className="legal-section">
          <h2>1. Shipping Regions</h2>
          <p>
            We ship to customers in the following regions:
          </p>
          <ul>
            <li><strong>North America:</strong> United States and Canada</li>
            <li><strong>Europe:</strong> All EU countries, United Kingdom, Switzerland, Norway</li>
            <li><strong>Australia:</strong> Australia and New Zealand</li>
          </ul>
          <div className="policy-highlight">
            <p>We currently do not ship to PO boxes or military addresses.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>2. Processing Time</h2>
          <p>
            Orders are processed within 1-2 business days (Monday through Friday, excluding holidays). 
            Processing time is separate from shipping time and includes:
          </p>
          <ul>
            <li>Payment verification and authorization</li>
            <li>Quality check and packaging</li>
            <li>Preparation for shipment</li>
          </ul>
          <p>
            Orders placed on weekends or holidays will be processed on the next business day.
          </p>
        </div>

        <div className="legal-section">
          <h2>3. Shipping Methods and Timeframes</h2>
          
          <h3>North America</h3>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Shipping Method</th>
                <th>Delivery Time</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Standard Shipping</td>
                <td>7-14 business days</td>
                <td>$15.99</td>
              </tr>
              <tr>
                <td>Express Shipping</td>
                <td>3-7 business days</td>
                <td>$29.99</td>
              </tr>
              <tr>
                <td>Priority Shipping</td>
                <td>1-3 business days</td>
                <td>$49.99</td>
              </tr>
            </tbody>
          </table>

          <h3>Europe</h3>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Shipping Method</th>
                <th>Delivery Time</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Standard Shipping</td>
                <td>10-20 business days</td>
                <td>€18.99</td>
              </tr>
              <tr>
                <td>Express Shipping</td>
                <td>5-10 business days</td>
                <td>€35.99</td>
              </tr>
              <tr>
                <td>Priority Shipping</td>
                <td>2-5 business days</td>
                <td>€59.99</td>
              </tr>
            </tbody>
          </table>

          <h3>Australia</h3>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Shipping Method</th>
                <th>Delivery Time</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Standard Shipping</td>
                <td>12-21 business days</td>
                <td>AU$22.99</td>
              </tr>
              <tr>
                <td>Express Shipping</td>
                <td>7-14 business days</td>
                <td>AU$42.99</td>
              </tr>
              <tr>
                <td>Priority Shipping</td>
                <td>3-7 business days</td>
                <td>AU$69.99</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="legal-section">
          <h2>4. Free Shipping</h2>
          <p>
            We offer free standard shipping on orders over:
          </p>
          <ul>
            <li>North America: $199 USD</li>
            <li>Europe: €179 EUR</li>
            <li>Australia: $299 AUD</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>5. Order Tracking</h2>
          <p>
            Once your order ships, you will receive a confirmation email with tracking information. 
            You can track your package using:
          </p>
          <ul>
            <li>Your Minute account dashboard</li>
            <li>The tracking link in your shipping confirmation email</li>
            <li>The carrier's website directly</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>6. Customs and Duties</h2>
          <p>
            International customers may be subject to customs duties, taxes, and fees imposed by 
            their country's customs authority. These charges are:
          </p>
          <ul>
            <li>Not included in the product price or shipping cost</li>
            <li>The responsibility of the customer</li>
            <li>Determined by local customs authorities</li>
            <li>Must be paid before delivery can be completed</li>
          </ul>
          <div className="policy-highlight">
            <p>Minute is not responsible for any customs delays or additional fees.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>7. Delivery Issues</h2>
          
          <h3>Failed Delivery Attempts</h3>
          <p>
            If delivery fails due to incorrect address or unavailability, the carrier will typically 
            make 2-3 delivery attempts. After failed attempts, packages may be:
          </p>
          <ul>
            <li>Held at a local pickup location</li>
            <li>Returned to sender</li>
            <li>Subject to additional delivery fees</li>
          </ul>

          <h3>Lost or Damaged Packages</h3>
          <p>
            If your package is lost or damaged during shipping:
          </p>
          <ul>
            <li>Report the issue within 48 hours of expected delivery</li>
            <li>We will investigate with the shipping carrier</li>
            <li>Replacement or refund will be provided for confirmed losses</li>
            <li>Original packaging and photos may be required for damage claims</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>8. Address Changes</h2>
          <p>
            Address changes are only possible before the order has been shipped. Once shipped, 
            we cannot modify the delivery address. To request an address change:
          </p>
          <ul>
            <li>Contact customer service immediately</li>
            <li>Provide your order number and new address</li>
            <li>Additional fees may apply for address corrections</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>9. Shipping Restrictions</h2>
          <p>
            We cannot ship to:
          </p>
          <ul>
            <li>Countries under international sanctions</li>
            <li>Remote islands or territories with limited postal access</li>
            <li>Military bases (APO/FPO addresses)</li>
            <li>PO boxes (for security and insurance purposes)</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>10. Peak Season Delays</h2>
          <p>
            During peak shopping seasons (Black Friday, Christmas, etc.), shipping times may be 
            extended due to increased volume. We recommend ordering early during these periods.
          </p>
        </div>

        <div className="legal-section">
          <h2>11. Contact Information</h2>
          <p>
            For shipping-related questions or issues, please contact:
          </p>
          <p>
            Email: shipping@minute.com<br/>
            Phone: +91-XXX-XXX-XXXX<br/>
            Support Hours: Monday-Friday, 9 AM - 6 PM IST
          </p>
        </div>

        <div className="legal-footer">
          <p><strong>Last Updated:</strong> January 2025</p>
        </div>
      </div>
    </div>
  );
};

export { ShippingPolicy };